export default "__VITE_ASSET__EcmEDCUF__"